var exports = {
  "h": "x936d19a0--964a00--description",
};

module.exports = exports;
